import { useEffect, useState } from 'react';
import './BottomSignalText.scss';

const BottomSignalText = (
    { pageSignal }: { pageSignal?: string }
) => {
    const [showHeader, setShowHeader] = useState(false);
    const [pageSignals, setPageSignals] = useState<string[]>([]);
    const [currentTab, setCurrentTab] = useState(0);

    useEffect(() => {
        if (pageSignal === undefined) return;
        const tempPageSignals = pageSignal.split('or');
        setPageSignals(tempPageSignals);
        if (tempPageSignals.length > 1) {
            setShowHeader(true);
        } else {
            setShowHeader(false);
        }
    }, [pageSignal]);

    if (!pageSignal) return null;

    return <div className={`button-signal-text ${showHeader ? 'show-header' : ''}`}>
        {showHeader &&
            <div className='button-signal-text-header'>
                <button
                    onClick={() => setCurrentTab(0)}
                    className={`tab-button ${currentTab === 0 ? 'active' : ''}`}
                    >Room</button>
                <button
                    onClick={() => setCurrentTab(1)}
                    className={`tab-button ${currentTab === 1 ? 'active' : ''}`}
                    >Global</button>
            </div>
        }

        <div className='displays-when'>
            {'Displays When '}
            {pageSignals.map((signal, index) => {
                const hasAnd = signal.includes('&');
                return <span key={signal} style={currentTab === index ? { display: 'inline' } : { display: 'none' }}>
                    {signal} {hasAnd ? 'are' : 'is'} high</span>;
            })}
        </div>
    </div>
}

export default BottomSignalText;
